import { render, staticRenderFns } from "./AssignCustomReportComponent.vue?vue&type=template&id=bf4d9904&"
import script from "./AssignCustomReportComponent.vue?vue&type=script&lang=js&"
export * from "./AssignCustomReportComponent.vue?vue&type=script&lang=js&"
import style0 from "./AssignCustomReportComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports